import { createSelector } from '@reduxjs/toolkit';

interface RootState {
  auth: {
    user: { email?: string } | null;
    isUserLogin: boolean;
  };
}

export const selectAuthState = (state: RootState) => state.auth;
export const selectUser = (state: RootState) => state.auth.user;
export const selectIsUserLogin = (state: RootState) => state.auth.isUserLogin;

export const selectUserEmail = createSelector(
  [selectUser],
  (user) => user?.email || null
);

export const selectIsAuthenticated = createSelector(
  [selectIsUserLogin],
  (isUserLogin) => isUserLogin
);
